import React, { PropsWithChildren } from 'react';
import { HiddenInput } from '../HiddenInput/HiddenInput';
import { ButtonMinorAction } from '../../../../components/molecules/Btn/ButtonWrapper';
import { Icons } from '../../../../components/atoms/SVG';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { SelectListItemBasic } from './SelectListItemBasic';

type SelectListItemHiddenInputProps = PropsWithChildren<{
  title: string;
  name: string;
  value: string;
  deleteButtonTitle: string;
  deleteElement(): void;
  ariaControls: string;
  href?: string;
}>;

export function SelectListItemHiddenInput({
  title,
  name,
  value,
  deleteButtonTitle,
  deleteElement,
  ariaControls,
  href,
}: Readonly<SelectListItemHiddenInputProps>) {
  return (
    <SelectListItemBasic title={title}>
      <div className="select-list__interactions">
        <HiddenInput name={name} value={value} />
        <ButtonMinorAction
          icon={Icons.DELETE_X_SMALL}
          text={deleteButtonTitle}
          onClick={deleteElement}
          ariaControls={ariaControls}
          href={href}
          tooltipPlacement={TooltipPlacement.LEFT}
        />
      </div>
    </SelectListItemBasic>
  );
}
